var _desc;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCropOlivoOver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "agrismart-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), /*#__PURE__*/React.createElement("g", {
    id: "agrismart-icon",
    transform: "scale(.34783)",
    style: {
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "m69 34.5c0 19.022-15.478 34.5-34.5 34.5s-34.5-15.478-34.5-34.5 15.478-34.5 34.5-34.5 34.5 15.478 34.5 34.5z",
    style: {
      clipRule: "evenodd",
      fill: "#fff",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      strokeWidth: 0.11815
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "m25.993 37.099-1.0634-1.4178c3.899-2.8356 15.95-11.342 31.31-8.3887l0.9452 2.8356c-15.36-2.9538-27.411 4.1353-31.192 6.9709z",
    style: {
      clipRule: "evenodd",
      fillOpacity: 0.94118,
      fill: "#009846",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      strokeWidth: 0.11815
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "m39.344 34.618c0.82705-1.0634 1.7723-1.7723 2.9538-2.363 0.2363-0.11815 0.4726-0.2363 0.82705-0.35445-0.11815-0.4726-0.35445-0.82706-0.4726-1.2997-0.2363-0.59075-0.4726-1.1815-0.7089-1.8904l-2.0086 0.59075c0.11815 0.59075-0.11815 2.9538-0.4726 5.1986z",
    style: {
      clipRule: "evenodd",
      fillOpacity: 0.94118,
      fill: "#009846",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      strokeWidth: 0.11815
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "m29.42 34.5c-4.6079 2.9538-8.1524 6.0257-10.752 7.6798 1.2997-1.0634 5.4349-4.9623 10.043-8.5068-7.4435-0.82706-17.604 13.115-18.904 15.714 3.899-1.2997 18.55-8.2705 19.613-14.887z",
    style: {
      clipRule: "evenodd",
      fillOpacity: 0.94118,
      fill: "#009846",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      strokeWidth: 0.11815
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "m34.5 30.601c-5.4349-0.11815-10.043-0.82706-13.115-0.82706 1.6541 0.2363 7.2072 1.4178 12.997 1.8904-5.9075 4.6079-21.858-1.8904-24.339-3.4264 4.0171-0.94521 20.086-2.7175 24.457 2.2449z",
    style: {
      clipRule: "evenodd",
      fillOpacity: 0.94118,
      fill: "#009846",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      strokeWidth: 0.11815
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "m42.534 28.002c-5.0805-1.8904-9.2158-4.0171-12.17-5.0805 1.536 0.7089 6.3801 3.6627 11.697 6.0257-7.089 2.4812-20.086-8.8613-21.858-11.106 4.1353 0.35445 19.849 4.0171 22.449 10.161z",
    style: {
      clipRule: "evenodd",
      fillOpacity: 0.94118,
      fill: "#009846",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      strokeWidth: 0.11815
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "m50.805 26.938c-4.6079-2.9538-8.1524-5.9075-10.752-7.5616 1.2997 1.0634 5.4349 4.9623 10.043 8.3887-7.4435 0.9452-17.723-12.997-19.022-15.596 3.899 1.2997 18.55 8.1524 19.731 14.651z",
    style: {
      clipRule: "evenodd",
      fillOpacity: 0.94118,
      fill: "#009846",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      strokeWidth: 0.11815
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "m39.226 46.551c-2.0086-4.4897-1.8904-8.0342-0.82706-10.397-2.363-0.35445-5.1986 0.82706-8.2705 3.7808-4.4897 4.6079-4.726 8.8613-2.2449 11.342 2.4812 2.4812 6.8527 2.2449 11.342-2.363 0.2363-0.2363 0.59075-0.59075 0.82706-0.82706-0.2363-0.4726-0.59075-1.0634-0.82706-1.6541z",
    style: {
      clipRule: "evenodd",
      fillOpacity: 0.94118,
      fill: "#009846",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      strokeWidth: 0.11815
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "m37.217 38.635c0.59075 0.7089 0.2363 1.8904-1.1815 2.9538-1.4178 1.0634-2.5993 1.0634-3.1901 0.2363-0.59075-0.7089-0.2363-1.8904 1.1815-2.9538s2.5993-1.0634 3.1901-0.2363z",
    style: {
      clipRule: "evenodd",
      fill: "#fff",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      strokeWidth: 0.11815
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "m51.041 51.868c-3.1901 1.4178-7.2072-0.35445-9.8065-6.1438-2.5993-5.9075-1.2997-10.043 1.8904-11.461 3.1901-1.4178 7.2072 0.35445 9.8065 6.1438 2.5993 5.9075 1.2997 10.043-1.8904 11.461z",
    style: {
      clipRule: "evenodd",
      fillOpacity: 0.94118,
      fill: "#009846",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      strokeWidth: 0.11815
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "m51.632 47.497c-0.82705 0.2363-1.8904-0.35445-2.363-2.1267s0-2.8356 0.82706-3.0719c0.82705-0.2363 1.8904 0.35445 2.363 2.1267s0 2.8356-0.82706 3.0719z",
    style: {
      clipRule: "evenodd",
      fill: "#fff",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      strokeWidth: 0.11815
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCropOlivoOver);
export default __webpack_public_path__ + "static/media/crop-olivo-over.2f14a12b6dbe9fde8c4a76ef12d4c4ae.svg";
export { ForwardRef as ReactComponent };